<template>
  <div>
    <es-form :padding="{ padding: '0 1.15rem 1.15rem' }">
      <template #es-form>
        <div class="row removeUnderline">
          <div class="field is-horizontal">
            <div class="field-label is-normal">
              <label class="label">
                {{ getFieldLabel(`PER:${personType}:DIRECTMATCH:STATE_STUDENT_ID`) }}
              </label>
            </div>
            <div class="field-body">
              <div class="field">
                <div class="control">
                  <input
                    class="input"
                    :class="{'is-danger' : hasErrorStateId}"
                    v-model="stateId"
                  />
                </div>
                <p
                  v-if="hasErrorStateId"
                  class="help is-danger"
                >
                  {{ msgStateId }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </template>
    </es-form>
    <div
      class="is-flex flex-justify--end flex-align--center"
      style="margin-right: 5.15rem; padding-bottom: 2rem"
    >
      <button
        class="button button-link has-underline"
        @click="reset"
        style="margin-right: 1rem"
        :disabled="loadingMatch"
      >
        Reset
      </button>
      <button
        class="button is-primary"
        @click="checkForm"
        :disabled="loadingMatch"
      >
        {{ properties['BUTTON_LABEL-ASSIGN_EXISTING'] }}
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import EsForm from '@/components/EsForm.vue';
import FieldLabels from '@/mixins/FieldLabels';
import NotificationManager from '@/mixins/NotificationManager';

export default {
  mixins: [
    FieldLabels,
    NotificationManager,
  ],
  components: {
    EsForm,
  },
  props: {
    // value coming from router to help return the match type id for the give matchTypeCode.
    matchTypeCode: {
      type: String,
    },
    personType: {
      type: String,
    },
    studentId: {
      type: String,
    },
  },
  data() {
    return {
      hasErrorStateId: null,
      loadingMatch: null,
      msgStateId: null,
      stateId: this.studentId,
    };
  },
  async created() {
    await this.loadPersonTypes();
    if (this.studentId) {
      this.checkForm();
    }
  },
  computed: {
    ...mapGetters('propertiesModule', [
      'properties',
    ]),
  },
  methods: {
    ...mapActions('lookups', [
      'loadPersonTypes',
    ]),
    checkForm() {
      this.hasErrorStateId = false;
      this.msgStateId = null;

      const match = /\d{4}-\d{2}-\d{4}/i.test(this.stateId);

      if (!this.stateId) {
        this.hasErrorStateId = true;
        this.msgStateId = `${this.getFieldLabel(`PER:${this.personType}:ASSIGN:STATE_STUDENT_ID`)} is required`;
      } else if (this.stateId.length === 12 ? !match : this.stateId.length !== 10) {
        this.hasErrorStateId = true;
        this.msgStateId = `${this.getFieldLabel(`PER:${this.personType}:ASSIGN:STATE_STUDENT_ID`)} is invalid`;
      } else if (this.stateId !== this.studentId) {
        this.hasErrorStateId = false;
        this.msgStateId = '';
        this.match();
      }
      if (this.hasErrorStateId) this.showNotification('danger', ['There were some errors. Please fix the errors highlighted in the fields below.']);
    },
    match() {
      const stateId = this.stateId ? this.stateId.split('-').join('') : this.stateId;
      this.$router.replace({
        path: '',
        query: { studentId: stateId },
      });
    },
    reset() {
      this.hasErrorStateId = null;
      this.msgStateId = null;
      this.stateId = null;
      this.hideNotification();

      // remove studentId queryParam from url
      if (this.studentId) {
        this.$router.replace({ path: '' });
      }
    },
  },
};
</script>

<style lang="sass" scoped>
</style>
